var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-0.13873875449683293"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 55.5L124 185L248 55.5L189.307 0H58.6933L0 55.5Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 55.5L124 185L248 55.5L189.307 0H58.6933L0 55.5Z",
    fill: "rgba(191, 191, 191, 100)",
    transform: "scale(1.2096774193548387, 1.6216216216216217)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 55.5L124 185L248 55.5L189.307 0H58.6933L0 55.5Z",
    fill: "none",
    stroke: "#0c0c0c",
    strokeWidth: 0,
    clipPath: "url(#clip-0.13873875449683293)",
    transform: "scale(1.2096774193548387, 1.6216216216216217)",
    strokeDasharray: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg22);
export default __webpack_public_path__ + "static/media/22.18de968b43ff04540716694db8efdb53.svg";
export { ForwardRef as ReactComponent };